import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// views without layouts

import Landing from "views/Landing.js";
import AnalysisPage from "views/AnalysisPage.js";
import AssistantPage from "views/AssistantPage";
import RedirectPage from "views/RedirectPage";
import LoginPage from "views/LoginPage";
import ArticlePage from "views/ArticlePage";


function App() {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const gclid = params.get('gclid');
        if (gclid) {
            console.log("GCLID captured:", gclid);
            localStorage.setItem('gclid', gclid);
        }
    }, [location]);

    return (
        <Routes>
            <Route path="/" element={<Landing pageName={''} />} />
            <Route path="/subasta" element={<AssistantPage />} />
            <Route path="/subasta/:id" element={<AnalysisPage />} />
            <Route path="/gracias" element={<RedirectPage />} />
            <Route path="/asistente" element={<AssistantPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path='/:id' element={<ArticlePage />} />
        </Routes>
    );
}

export default App;